import React from 'react';
import { X } from 'lucide-react';
import { Button, Text, IconButton } from './ui';
import useClickOutside from '../hooks/useClickOutside';
import useMediaQuery from '../hooks/useMediaQuery';

const DisconnectConfirmModal = ({ isOpen, onClose, onConfirm, account }) => {
  const modalRef = useClickOutside(onClose);
  const { isMobile } = useMediaQuery();

  if (!isOpen || !account) return null;

  // Get display name: pageName for Facebook, username for Instagram
  const displayName = account.username || account.pageName || account.platform;
  const platformName =
    account.platform === 'facebook'
      ? 'Facebook'
      : account.platform === 'instagram' || account.platform === 'instagram_business'
      ? 'Instagram'
      : account.platform;

  return (
    <div className='modal-overlay'>
      <div
        ref={modalRef}
        className='modal-content w-full max-w-md'
      >
        {/* Header */}
        <div className='flex items-center justify-between p-6' style={{ borderBottom: '1px solid var(--border)' }}>
          <Text variant='title' className={isMobile ? 'text-base' : ''}>
            Disconnect Account
          </Text>
          <IconButton icon={X} onClick={onClose} variant='ghost' tooltip='Close' />
        </div>

        {/* Content */}
        <div className='p-6'>
          <div className='mb-6'>
            <p className={`mb-4 ${isMobile ? 'text-sm' : ''}`} style={{ color: 'var(--text-body)' }}>
              Are you sure you want to disconnect{' '}
              <span className='font-semibold' style={{ color: 'var(--text-primary)' }}>"{displayName}"</span> from{' '}
              <span className='font-semibold' style={{ color: 'var(--text-primary)' }}>{platformName}</span>?
            </p>
            <p className={isMobile ? 'text-xs' : 'text-sm'} style={{ color: 'var(--text-muted)' }}>
              You will need to reconnect this account to schedule posts to it in the future.
            </p>
          </div>
          <div className='flex items-center justify-end gap-3'>
            <Button type='button' size='md' variant='secondary' onClick={onClose}>
              Cancel
            </Button>
            <Button type='button' size='md' variant='danger' onClick={onConfirm}>
              Disconnect
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisconnectConfirmModal;
